import { Icon } from '@iconify/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/Domain/components/Shared/Button/Button';

interface ScriptDisplayProps {
  script: string;
  onCopy?: () => void;
}

export const WidgetScript = ({ script, onCopy }: ScriptDisplayProps) => {
  const { t } = useTranslation('common');
  const [copied, setCopied] = useState(false);

  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text).then(
      () => {
        setCopied(true);
        onCopy?.();
      },
      (err) => {
        console.error('Could not copy text: ', err);
      },
    );
  };

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => {
        setCopied(false);
      }, 3000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [copied]);

  return (
    <div className="relative mt-2 rounded-2xl border border-border bg-muted p-3 text-muted-foreground">
      {/* Box hugs the actual code height. The Copy button floats absolutely
          over the bottom-right corner — script snippets here all end with a
          short `</script>` on the left, so the right corner is empty and the
          overlay doesn't hide any real content. */}
      <pre className="mb-0 overflow-x-auto whitespace-pre font-mono text-xs leading-relaxed">
        <code>{script}</code>
      </pre>
      <Button
        size="xs"
        variant="dark"
        onClick={() => copyToClipboard(script)}
        className="absolute right-2 bottom-2"
      >
        {copied ? (
          <>
            <Icon icon="mingcute:check-fill" />
            {t('copied')}
          </>
        ) : (
          <>
            <Icon icon="mingcute:clipboard-fill" />
            {t('copy')}
          </>
        )}
      </Button>
    </div>
  );
};
